export default __webpack_public_path__ + "navigation-examples-building-extrusion-thumbnail-v1-960-cc31b401b1ce6efe9dae093962f4c215.png";